import PersonalProfile from './personal-profile';

export default PersonalProfile;
